<template>
<div class="bg-white px-3 py-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
	  <el-form ref="form" :model="configForm" label-width="300px" v-loading="formLoading">
              <table class="table table-bordered myTable ">
                <tr>
                  <td>
                     <el-form-item :label="$t('searchText.jackpot금액')" class="mb-0  configItem">
                          <el-input v-model="configForm.jackpot_money" style="width: 120px;" class="ml-2 mr-2"></el-input>{{$t('searchText.원')}}
                     </el-form-item>
                  </td>
                </tr>
                 <tr>
                  <td>
                     <el-form-item label="house money:" class="mb-0  configItem">
                          <el-input v-model="configForm.house_money" style="width: 120px;"  class="ml-2 mr-2"></el-input>{{$t('searchText.원')}}
                     </el-form-item>
                  </td>
                </tr>
                <tr>
                  <td>
                     <el-form-item :label="$t('searchText.주간출금랭킹Top1ID')" class="mb-0  configItem">
                          <el-input v-model="configForm.week_id" style="width: 120px;" class="ml-2 mr-2"></el-input>
                     </el-form-item>
                  </td>
                </tr>
                 <tr>
                  <td>
                     <el-form-item :label="$t('searchText.주간출금랭킹Top1머니')" class="mb-0  configItem">
                          <el-input v-model="configForm.week_money" style="width: 120px;"  class="ml-2 mr-2"></el-input>{{$t('searchText.원')}}
                     </el-form-item>
                  </td>
                </tr>
                 <tr>
                  <td>
                     <el-form-item :label="$t('searchText.바카라점검')" class="mb-0  configItem">
                          <el-radio-group v-model="configForm.b_45" class="ml-2">
                              <el-radio label="0">{{$t('searchText.서비스')}}</el-radio>
                              <el-radio label="1">{{$t('searchText.점검중')}}</el-radio>
                            </el-radio-group>
                     </el-form-item>
                  </td>
                </tr>
                 <tr>
                  <td>
                     <el-form-item :label="$t('searchText.슬롯점검')" class="mb-0  configItem">
                          <el-radio-group v-model="configForm.s_23" class="ml-2">
                              <el-radio label="0">{{$t('searchText.서비스')}}</el-radio>
                              <el-radio label="1">{{$t('searchText.점검중')}}</el-radio>
                            </el-radio-group>
                     </el-form-item>
                  </td>
                </tr>
                 <tr>
                  <td>
                     <el-form-item :label="$t('searchText.서비스점검')" class="mb-0  configItem">
                          <el-radio-group v-model="configForm.maintain" class="ml-2">
                              <el-radio label="0">{{$t('searchText.서비스')}}</el-radio>
                              <el-radio label="1">{{$t('searchText.점검중')}}</el-radio>
                            </el-radio-group>
                     </el-form-item>
                  </td>
                </tr>
                 <tr>
                  <td>
                     <el-form-item :label="$t('searchText.점검중멘트')" class="mb-0  configItem h200">
                          <el-input
                          type="textarea"
                          :rows="4"
                          v-model="configForm.maintain_ment" class="ml-2 mt-2 mb-2 w-75">
                        </el-input>
                     </el-form-item>
                  </td>
                </tr>
                 <tr>
                  <td>
                     <el-form-item :label="$t('searchText.관리자접속가능아이피')" class="mb-0  configItem h200">
                          <el-input
                          type="textarea"
                          :rows="4"
                          v-model="configForm.admin_ip" class="ml-2 mt-2 mb-2 w-75">
                        </el-input>
                     </el-form-item>
                  </td>
                </tr>
                <tr>
                  <td>
                     <el-form-item :label="$t('searchText.환전최소금액')" class="mb-0  configItem">
                          <el-input v-model="configForm.exchange_money" style="width: 120px;" class="ml-2 mr-2"></el-input>
                     </el-form-item>
                  </td>
                </tr>
                 <tr>
                  <td>
                     <el-form-item :label="$t('searchText.회최대환전금액')" class="mb-0  configItem">
                          <el-input v-model="configForm.ex_once" style="width: 120px;"  class="ml-2 mr-2"></el-input>{{$t('searchText.원')}}
                     </el-form-item>
                  </td>
                </tr>
                <tr>
                  <td>
                     <el-form-item :label="$t('searchText.일최대환전금액')" class="mb-0  configItem">
                          <el-input v-model="configForm.ex_day" style="width: 120px;" class="ml-2 mr-2"></el-input>{{$t('searchText.원')}}
                     </el-form-item>
                  </td>
                </tr>
                 <tr>
                  <td>
                     <el-form-item :label="$t('searchText.재환전신청가능시간')" class="mb-0  configItem">
                          <el-input v-model="configForm.ex_time" style="width: 120px;"  class="ml-2 mr-2"></el-input>{{$t('searchText.분')}}
                     </el-form-item>
                  </td>
                </tr>
                 <tr>
                  <td>
                     <el-form-item :label="$t('searchText.은행계좌')" class="mb-0  configItem">
                         <span class="ml-2">{{$t('tableText.은행명')}}:</span><el-input v-model="configForm.bank" style="width: 120px;"  class="ml-2 mr-2"></el-input>{{$t('tableText.계좌번호')}} :<el-input v-model="configForm.bank_num" style="width: 120px;"  class="ml-2 mr-2"></el-input>{{$t('tableText.예금주')}}:<el-input v-model="configForm.name" style="width: 120px;"  class="ml-2 mr-2"></el-input>
                     </el-form-item>
                  </td>
                </tr>
                  <tr>
                  <td>
                     <el-form-item :label="$t('searchText.회원가입시추천인')" class="mb-0  configItem">
                          <el-radio-group v-model="configForm.member_join_chu" class="ml-2">
                              <el-radio label="1">{{$t('searchText.입력필수')}}</el-radio>
                              <el-radio label="2">{{$t('searchText.필수아님')}}</el-radio>
                            </el-radio-group>
                     </el-form-item>
                  </td>
                </tr>
                 <tr>
                  <td>
                     <el-form-item :label="$t('searchText.회원한줄광고')" class="mb-0  configItem">
                          <el-input v-model="configForm.ad" style="width: 620px;" class="ml-2 mr-2"></el-input>
                     </el-form-item>
                  </td>
                </tr>
                <tr>
                  <td>
                     <el-form-item :label="$t('searchText.총판한줄공지')" class="mb-0  configItem">
                          <el-input v-model="configForm.sms_betting_ok_msg" style="width: 620px;" class="ml-2 mr-2"></el-input>
                     </el-form-item>
                  </td>
                </tr>
                <tr>
                  <td>
                     <el-form-item :label="$t('searchText.가입쪽지제목설정')" class="mb-0  configItem">
                          <el-input v-model="configForm.wel_memo_title" style="width: 620px;" class="ml-2 mr-2"></el-input>
                     </el-form-item>
                  </td>
                </tr>
                 <tr>
                  <td>
                     <el-form-item :label="$t('searchText.가입쪽지문구설정')" class="mb-0  configItem h200">
                          <el-input
                          type="textarea"
                          :rows="4"
                          v-model="configForm.wel_memo_content" class="ml-2 mt-2 mb-2 w-75">
                        </el-input>
                     </el-form-item>
                  </td>
                </tr>
                 <tr>
                  <td>
                     <el-form-item :label="$t('searchText.고객센터가상계좌')" class="mb-0  configItem h200">
                          <el-input
                          type="textarea"
                          :rows="4"
                          v-model="configForm.qna_1" class="ml-2 mt-2 mb-2 w-75">
                        </el-input>
                     </el-form-item>
                  </td>
                </tr>
                 <tr>
                  <td>
                     <el-form-item :label="$t('searchText.고객센터온라인계좌')" class="mb-0  configItem h200">
                          <el-input
                          type="textarea"
                          :rows="4"
                          v-model="configForm.qna_2" class="ml-2 mt-2 mb-2 w-75">
                        </el-input>
                     </el-form-item>
                  </td>
                </tr>
                 <tr>
                  <td>
                     <el-form-item :label="$t('searchText.고객센터지인계좌')" class="mb-0  configItem h200">
                          <el-input
                          type="textarea"
                          :rows="4"
                          v-model="configForm.qna_3" class="ml-2 mt-2 mb-2 w-75">
                        </el-input>
                     </el-form-item>
                  </td>
                </tr>
                 <tr>
                  <td>
                     <el-form-item :label="$t('searchText.고객센터지인계좌')" class="mb-0  configItem h200">
                          <el-input
                          type="textarea"
                          :rows="4"
                          v-model="configForm.qna_5" class="ml-2 mt-2 mb-2 w-75">
                        </el-input>
                     </el-form-item>
                  </td>
                </tr>
                 <tr>
                  <td>
                     <el-form-item :label="$t('searchText.고객센터요청처리완료')" class="mb-0  configItem h200">
                          <el-input
                          type="textarea"
                          :rows="4"
                          v-model="configForm.qna_4" class="ml-2 mt-2 mb-2 w-75">
                        </el-input>
                     </el-form-item>
                  </td>
                </tr>
                 <tr>
                  <td>
                     <el-form-item :label="$t('searchText.고객센터대기멘트')" class="mb-0  configItem h200">
                          <el-input
                          type="textarea"
                          :rows="4"
                          v-model="configForm.qna_6" class="ml-2 mt-2 mb-2 w-75">
                        </el-input>
                     </el-form-item>
                  </td>
                </tr>
                 <tr>
                  <td>
                     <el-form-item :label="$t('searchText.고객센터여신불가')" class="mb-0  configItem h200">
                          <el-input
                          type="textarea"
                          :rows="4"
                          v-model="configForm.qna_7" class="ml-2 mt-2 mb-2 w-75">
                        </el-input>
                     </el-form-item>
                  </td>
                </tr>
                 <tr>
                  <td>
                     <el-form-item :label="$t('searchText.고객센터서비스불가')" class="mb-0  configItem h200">
                          <el-input
                          type="textarea"
                          :rows="4"
                          v-model="configForm.qna_8" class="ml-2 mt-2 mb-2 w-75">
                        </el-input>
                     </el-form-item>
                  </td>
                </tr>
                 <tr>
                  <td>
                     <el-form-item :label="$t('searchText.고객센터환전지연')" class="mb-0  configItem h200">
                          <el-input
                          type="textarea"
                          :rows="4"
                          v-model="configForm.qna_9" class="ml-2 mt-2 mb-2 w-75">
                        </el-input>
                     </el-form-item>
                  </td>
                </tr>
                 <tr>
                  <td>
                     <el-form-item :label="$t('searchText.고객센터인터넷불량')" class="mb-0  configItem h200">
                          <el-input
                          type="textarea"
                          :rows="4"
                          v-model="configForm.qna_10" class="ml-2 mt-2 mb-2 w-75">
                        </el-input>
                     </el-form-item>
                  </td>
                </tr>
              
              
                </table>
                <div class="mt-2 text-center">
                    <el-button type="primary" @click="confirmOk">{{$t('searchText.저장')}}</el-button>
                </div>
      
   
  

          </el-form>
	
  
</div>
 </template>

 <script>



    export default {
   
    	data(){
    		return{
          formLoading:false,
         configForm:{
          jackpot_money:'',
          house_money:'',
          week_id:'',
          week_money:'',
          b_45:'',
          s_23:'',
          maintain:'',
          maintain_ment:'',
          admin_ip:'',
          exchange_money:'',
          ex_once:'',
          ex_day:'',
          ex_time:'',
          bank:'',
          bank_num:'',
          name:'',
          member_join_chu:'',
          sms_betting_ok_msg:'',
          wel_memo_title:'',
          ad:'',
          wel_memo_content:'',
          qna_10:'',
          qna_1:'',
          qna_2:'',
          qna_3:'',
          qna_4:'',
          qna_5:'',
          qna_6:'',
          qna_7:'',
          qna_8:'',
          qna_9:'',

         }
    			
    			}
    		},
        
    		created() {
         
    			
			
		},
    	
    	methods:{

    confirmOk(){},
    		
    	
    		
    	}
  }
</script>

 <style scoped>
 >>>.el-input__inner{
  height: 30px;
  line-height: 30px;
 }
</style>


// WEBPACK FOOTER //
// src/views/configlist/list.vue